/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Collapse, Button } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { useEffect, useRef, useState } from "react"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"

import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { Form } from "react-bootstrap"
import Spinner from "../../../components/Spinner"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import { 区分分類コード } from "../../../constant/enum/codes"
import {
  TKaikonZyutyuHaisyaTableReq,
  TKaikonZyutyuHaisyaListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"

import KaikonZyutyuHaisyaService from "../../../service/orderContainer/kaikonZyutyuHaisya/kaikonZyutyuHaisyaService"
import { KaikonZyutyuHaisyaTableProvider } from "./KaikonZyutyuHaisyaTableContext"
import KaikonZyutyuHaisyaListGrid from "./KaikonZyutyuHaisyaTableGrid"
import dateUtil from "../../../ts/util/dateUtil"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"

import CONSTANT from "../../../constant"

// TODO:型定義は別枠に
type TOmitDisplay =
  | "受注部所コード"
  | "表紙分割コード"
  | "請求内訳コード"
  // | "付替区分コード"
  | "車種区分コード"
  | "運行部所コード"
  | "配車状態区分コード"
  | "確認区分コード"
  | "請求額確認区分コード"
  | "傭車会社あり対象フラグ"
  | "表示順区分コード"
  | "オーダー備考"
  | "オーダー内容"
  | "オーダー指定時間"

type T表示用検索条件 = Omit<TKaikonZyutyuHaisyaTableReq, TOmitDisplay> &
  Partial<{
    受注部所: string
    表紙分割?: string
    請求内訳?: string
    // 付替区分?: string
    車種区分?: string
    運行部所?: string
    配車状態区分?: string
    確認区分?: string
    傭車あり: boolean
    表示順区分: string
    備考?: string
    内容?: string
    指定時間?: string
  }>

const KaikonZyutyuHaisyaTable = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "kaikonZyutyuHaisyaTable_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件>()

  const [preSearchCondition, setPreSearchCondition] =
    useState<TKaikonZyutyuHaisyaTableReq>()

  const [searchResult, setSearchResult] =
    useState<TKaikonZyutyuHaisyaListGetRes[]>()

  //１列目
  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //const [付替区分コード, set付替区分コード] = useState<string | null>()
  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)

  //２列目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主略称1, set荷主略称1] = useState<string>()
  const [荷主依頼番号, set荷主依頼番号] = useState<string>()
  const [コンテナ番号, setコンテナ番号] = useState<string>()

  const [検索結果受注部所コード, set検索結果受注部所コード] =
    useState<string>("")

  const [表示順区分コード, set表示順区分コード] = useState<string | null>()
  //#endregion

  //#region [comboboxState]

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 付替区分
  //const [付替区分ComboBox, set付替区分ComboBox] = useState<TWijmoComboBox<
  //string,
  //T区分マスタ
  //> | null>(null)
  //const [付替区分isLoadEnded, set付替区分isLoadEnded] = useState<boolean>(false)

  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  // 表示順
  const [表示順区分ComboBox, set表示順区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [表示順区分isLoadEnded, set表示順区分isLoadEnded] =
    useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded) {
      let querySearchCondition: TKaikonZyutyuHaisyaTableReq | undefined =
        undefined
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        querySearchCondition = queryParse()
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
        // リストア中フラグON
        setIsRestoreSearching(true)
      } else {
        set受注部所コード(userInfo.部所コード)
        querySearchCondition = {
          受注部所コード: userInfo.部所コード,
          検索日From: 翌営業日,
          検索日To: 翌営業日,
        }
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded])

  //#endregion

  //#region [method]

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: Partial<TKaikonZyutyuHaisyaTableReq> = queryString.parse(
      location.search
    )
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? null)
    set荷主コード(query.荷主コード)
    set荷主略称1(query.荷主略称1)

    setコンテナ番号(query.コンテナ番号)
    //set付替区分コード(query.付替区分コード)
    set荷主依頼番号(query.荷主依頼番号)
    set運行部所コード(query.運行部所コード ?? null)
    if (query.検索日From || query.検索日To) {
      set検索日From(query.検索日From)
      set検索日To(query.検索日To)
    }
    set表示順区分コード(query.表示順区分コード)
    return query as TKaikonZyutyuHaisyaTableReq
  }

  /**
   * 検索
   */
  const search = async (searchCondition?: TKaikonZyutyuHaisyaTableReq) => {
    //遷移の制御確認
    if (isPrompt.current) {
      if (window.confirm(CONSTANT.MESSAGES.BROWSER_BACK)) {
        isPrompt.current = false
      } else {
        return
      }
    }
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TKaikonZyutyuHaisyaTableReq | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // TODO:検索処理導入
    try {
      const service = new KaikonZyutyuHaisyaService()

      const res = await service.getHaisyaHyo(currentSearchCondition)

      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)

      setSearchResult([...res.data])
      setPreSearchCondition(currentSearchCondition)
      set検索結果受注部所コード(currentSearchCondition.受注部所コード ?? "")
      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)
    } catch (error) {
      dispatch(setAlerts(error))
      setIsSearching(false)
    } finally {
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TKaikonZyutyuHaisyaTableReq | undefined => ({
    荷主コード,
    荷主略称1: 荷主略称1,
    コンテナ番号: コンテナ番号,
    受注部所コード: 受注部所コード ?? "",
    荷主依頼番号,
    //付替区分コード: 付替区分コード ?? undefined,
    運行部所コード: 運行部所コード ?? undefined,
    表示順区分コード: 表示順区分コード ?? undefined,
    検索日From: 検索日From ?? "",
    検索日To: 検索日To ?? "",
  })

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TKaikonZyutyuHaisyaTableReq
  ): T表示用検索条件 | undefined => ({
    受注部所: 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.受注部所コード
    )?.部所名,
    // 付替区分: 区分ItemSource?.find(
    //   (i) =>
    //     i.区分コード === searchCondition.付替区分コード &&
    //     i.分類コード === 区分分類コード.受注配車_請求支払.付替区分
    //)?.名称1,
    運行部所: 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.運行部所コード
    )?.部所名,
    荷主コード: searchCondition.荷主コード,
    荷主名: searchCondition.荷主略称1,
    荷主依頼番号: searchCondition.荷主依頼番号,
    コンテナ番号: searchCondition.コンテナ番号,
    表示順区分: 区分ItemSource?.find(
      (i) =>
        i.区分コード === searchCondition.表示順区分コード &&
        i.分類コード ===
          区分分類コード.受注配車_請求支払.海コン受注配車入力表示順区分
    )?.名称1,
    検索日From: dateUtil.format(検索日From) ?? "",
    検索日To: dateUtil.format(検索日To) ?? "",
  })

  //#endregion
  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">海コン配車表一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-150rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-13rem">
                              <DateInput
                                id="検索日from"
                                placeholder="検索日From"
                                isRequired={true}
                                has1DayButton={true}
                                value={検索日From}
                                defaultValue={翌営業日}
                                setValue={(v) => {
                                  set検索日From(v)
                                }}></DateInput>
                            </div>
                            <div className="w-13rem">
                              <DateInput
                                id="検索日To"
                                placeholder="検索日To"
                                value={検索日To}
                                isRequired={true}
                                has1DayButton={true}
                                defaultValue={翌営業日}
                                setValue={(v) => {
                                  set検索日To(v)
                                }}></DateInput>
                            </div>
                            <div className=""></div>
                            <ComboBox.Busyo
                              placeholder="受注部所"
                              className={"busyo-combo-box"}
                              isLoadEnded={受注部所isLoadEnded}
                              setIsLoadEnded={set受注部所isLoadEnded}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              isAllSelect={true}
                              isEmpty={true}
                              isRequired={true}
                              itemsSource={部所ItemSource}
                              selectedValue={受注部所コード}
                              setSelectedValue={(v) => {
                                set受注部所コード(v)
                              }}
                              ComboBox={受注部所ComboBox}
                              setComboBox={
                                set受注部所ComboBox
                              }></ComboBox.Busyo>
                            {/* <div className="w-10rem">
                              <ComboBox.Kubun
                                placeholder="付替区分"
                                分類コード={
                                  区分分類コード.受注配車_請求支払.付替区分
                                }
                                isAllSelect={true}
                                isRequired={false}
                                isDisabled={
                                  受注部所コード === "" ||
                                  受注部所コード == null
                                }
                                itemsSource={区分ItemSource}
                                isLoadEnded={付替区分isLoadEnded}
                                setIsLoadEnded={set付替区分isLoadEnded}
                                selectedValue={付替区分コード}
                                setSelectedValue={(v) => {
                                  set付替区分コード(v)
                                }}
                                ComboBox={付替区分ComboBox}
                                setComboBox={
                                  set付替区分ComboBox
                                }></ComboBox.Kubun>
                            </div> */}
                            <ComboBox.Busyo
                              placeholder="運行部所"
                              isLoadEnded={運行部所isLoadEnded}
                              setIsLoadEnded={set運行部所isLoadEnded}
                              isAllSelect={true}
                              isRequired={false}
                              itemsSource={部所ItemSource}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={運行部所コード}
                              setSelectedValue={(v) => {
                                set運行部所コード(v)
                              }}
                              ComboBox={運行部所ComboBox}
                              setComboBox={
                                set運行部所ComboBox
                              }></ComboBox.Busyo>
                          </div>
                          <div className="search-condition-row">
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                setValue={(v) => {
                                  set荷主コード(v)
                                }}
                                maxLength={5}
                                placeholder="荷主CD"
                              />
                              <TextInput
                                id="荷主名"
                                name="荷主名"
                                value={荷主略称1}
                                setValue={set荷主略称1}
                                maxLength={100}
                                placeholder="荷主略称"
                              />
                            </div>

                            <div className="w-12rem">
                              <TextInput
                                id="荷主依頼No"
                                name="荷主依頼No"
                                value={荷主依頼番号}
                                setValue={set荷主依頼番号}
                                maxLength={100}
                                placeholder="荷主依頼No"
                              />
                            </div>
                            <TextInput
                              style={{ width: "19rem" }}
                              id="コンテナ番号"
                              name="コンテナ番号"
                              value={コンテナ番号}
                              setValue={(v) => {
                                setコンテナ番号(v)
                              }}
                              maxLength={11}
                              placeholder="コンテナ番号"
                            />

                            <ComboBox.Kubun
                              placeholder="表示順"
                              分類コード={
                                区分分類コード.受注配車_請求支払
                                  .海コン受注配車入力表示順区分
                              }
                              itemsSource={区分ItemSource}
                              isLoadEnded={表示順区分isLoadEnded}
                              isAllSelect={false}
                              isRequired={false}
                              setIsLoadEnded={set表示順区分isLoadEnded}
                              selectedValue={表示順区分コード}
                              setSelectedValue={(v) => {
                                set表示順区分コード(v)
                              }}
                              ComboBox={表示順区分ComboBox}
                              setComboBox={
                                set表示順区分ComboBox
                              }></ComboBox.Kubun>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()

                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col xs={12}>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <KaikonZyutyuHaisyaTableProvider
                isSearching={{ state: isSearching, setState: setIsSearching }}
                isRestoreSearching={{
                  state: isRestoreSearching,
                  setState: setIsRestoreSearching,
                }}
                SearchResult={searchResult}
                gridInitialized={{
                  state: gridInitialized,
                  setState: setGridInitialized,
                }}
                searchCondition={preSearchCondition}
                search={search}
                受注部所コード={検索結果受注部所コード}
                searchDyFrom={{
                  state: 検索日From,
                  setState: set検索日From,
                }}
                searchDyTo={{
                  state: 検索日To,
                  setState: set検索日To,
                }}
                searchUnkoBusyoCd={{
                  state: 運行部所コード,
                  setState: set運行部所コード,
                }}
                searchBusyoCd={{
                  state: 受注部所コード,
                  setState: set受注部所コード,
                }}
                isPrompt={isPrompt}>
                <KaikonZyutyuHaisyaListGrid
                  gridId={gridId}></KaikonZyutyuHaisyaListGrid>
              </KaikonZyutyuHaisyaTableProvider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default KaikonZyutyuHaisyaTable
